import { useFeatureFlag } from "src/utils/flags";
import { Session } from "src/modules/interface";
import { FeatureFlag } from "src/constants/FEATURE_FLAGS";

export function useActiveChatWindowDays(profile: Session["profile"]) {
  const activeChatWindowDaysFlag = useFeatureFlag<{ days: number | undefined }>(
    FeatureFlag.IN_APP_CHAT_LIMITED_DAYS_AFTER_BOOKED_SHIFT,
    {
      key: profile?.userId,
      name: profile?.name,
      email: profile?.email,
      msa: profile?.fullAddress?.metropolitanStatisticalArea,
      facilitymsa: profile?.fullAddress?.metropolitanStatisticalArea,
      city: profile?.fullAddress?.city,
      state: profile?.fullAddress?.state,
      facilityType: profile?.type,
    },
    { days: 30 }
  );
  return activeChatWindowDaysFlag.days;
}
